import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ToastState {
  severity: 'success' | 'info' | 'warn' | 'error' | null;
  summary: string;
  detail: string;
  visible: boolean;
  life?: number;
}

const initialState: ToastState = {
  severity: null,
  summary: '',
  detail: '',
  visible: false,
  life: 3000,
};

const toastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showToast: (state, action: PayloadAction<Omit<ToastState, 'visible'>>) => {
      state.severity = action.payload.severity;
      state.summary = action.payload.summary;
      state.detail = action.payload.detail;
      state.life = action.payload.life || 3000;
      state.visible = true;
    },
    hideToast: (state) => {
      state.visible = false;
    }
  }
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer; 